import React, { Component } from 'react';
import NoImage from './combined-shape.svg';
import IconUploadWhite from './icon_upload_white.svg';

class UploadButton extends Component {

  state = {
    selectedImage: [],
    maxFileSize: false,
  }
  compress = (e) => { 
    console.log(e);
    return new Promise((resolve, reject) => {
      const fileName = e.name;
      const reader = new FileReader();
      reader.readAsDataURL(e);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const elem = document.createElement('canvas');
          const imgWidth = img.width;
          const width = (imgWidth / 100) * 75;
          // const size = img.size / 1024 / 1024;
          const scaleFactor = width / imgWidth;
          elem.width = width;
          elem.height = img.height * scaleFactor;
          const ctx = elem.getContext('2d');
          ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          ctx.canvas.toBlob((blob) => {
            const file = new File([blob], fileName, {
              type: 'image/jpeg',
              lastModified: Date.now(),
            });
            resolve(file);
          }, 'image/jpeg', 0.75);
        };

        reader.onerror = error => reject(error);
      };
    });
  }

  fireGaEvent = () => {
    this.value = null;
  };

  handleChange = async () => {
    console.log('file..........');
    const { props } = this;
    // const fileType = this.inputRef.files &&
    // this.inputRef.files[0].name.split('.')[1].toLowerCase();
    const fileType = this.inputRef.files && this.inputRef.files[0].name.substring(this.inputRef.files[0].name.lastIndexOf('.') + 1, this.inputRef.files[0].name.length);
    // const { user } = props;
    // console.log('this.inputRef.files[0].size', this.inputRef.files[0].size / 1024 / 1024);
    const maxSize = 10;
    // const targetUrl = `${user._links.business.href}/proof_of_payments`;
    const validFileTypes = ['png', 'gif', 'jpg', 'jpeg', 'csv', 'xls', 'pdf',
      'doc', 'docx', 'xlsx', 'PDF', 'PNG', 'JPG', 'JPEG', 'XLS', 'XLSX', 'GIF'];
    const validImagetypes = ['png', 'gif', 'jpg', 'jpeg', 'JPG', 'PNG'];
    if (((this.inputRef.files[0].size / 1024 / 1024) > maxSize)) {
      this.inputRef.value = '';
      this.setState({
        maxFileSize: true
      });
      props.onInvalidFileSize();
    } else if (validFileTypes.indexOf(fileType) > -1) {
      if (this.inputRef.files[0]) {
        let compressed = this.inputRef.files[0];
        if (validImagetypes.indexOf(fileType) > -1) {
          compressed = await this.compress(this.inputRef.files[0]);
        }
        // const formData = new FormData();
        // formData.append('file_url', compressed);


        const reader = new FileReader();
        const file = this.inputRef.files[0];
        reader.onloadend = () => {
          this.setState({
            selectedImage: reader.result,
            fileName: file.name,
            maxFileSize: false,
          });
        };
        reader.readAsDataURL(file);

        props.selectedFile(compressed);
      }
    } else {
      this.inputRef.value = '';
      this.setState({
        selectedImage: [],
        fileName: '',
      });
      props.onInvalidFileSubmit();
    }
  };

  render() {
    const { props, state } = this;
    return (
      <div className={props.uploading ? 'screen-disable' : ''}>
        <div className="pop-upload-button">
          <label>Upload Image</label>
          <div className="upload-button-wrapper">
            <input
              id="myfile"
              type="file"
              accept=".xlsx,.xls, .png, .jpg, .jpeg, .doc, .docx,.ppt, .pptx,.txt,.pdf"
              name="myfile"
              onChange={this.handleChange}
            //   onClick={this.fireGaEvent}
              ref={(ref) => { this.inputRef = ref; }}
            />
          </div>
          {
            state.selectedImage.length > 0 && !state.maxFileSize &&
            <div className="complaint-multiple-uploads">
              <img src={state.selectedImage.includes('data:image/') ? state.selectedImage : NoImage} alt="" />
              <div>{state.fileName}</div>
              {/* <i className="icon-delete" onClick={() => { this.showDelConfirmPop(index); }} />
               */}
            </div>
          }
        </div>
      </div>
    );
  }
}

export default UploadButton;
